import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, MenuItem, Grid } from '@material-ui/core';
import { TextLink, Input as FormInput, Button } from '@ds/react-components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { connect } from 'react-redux';
import { ajaxActions } from 'common/ajax/store.js';
import ToastMessage from 'common/alert/ToastMessage.js';
import { actionCreators } from './store.js';

const styles = (theme) => ({
  root: {},
  paper: {
    maxWidth: '450px',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: 1.33,
  },
  content: {
    textAlign: 'left',
  },
  indicator: {
    fontSize: '14px',
    lineHeight: 1.33,
    color: '#666',
    paddingTop: '5px',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'right',
    },
  },
  edit: {
    position: 'relative',
    display: 'flex',
    float: 'right',
    top: '0px',
    right: '0px',
    color: '#004A8C',
    fontWeight: 'bold',
    fontStyle: 'normal',
    '&:hover': {
      color: '#004A8C !important',
    },
  },
  split: {
    padding: '24px 32px',
    border: `1px solid ${theme.palette.common.inputBorder}`,
  },
  updateButton: {
    backgroundColor: '#6AAC40 !important',
    borderColor: '#6AAC40',
    padding: '10px 16px !important',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#387C20 !important',
      borderColor: '#387C20',
    },
  },
  cancelButton: {
    color: '#9A9EA0',
    borderColor: '#9A9EA0',
    padding: '10px 16px !important',
    marginLeft: '16px',
    '&:hover': {
      color: '#626668',
      borderColor: '#626668',
      backgroundColor: '#fff !important',
    },
  },
  adorment: {
    '&>*': {
      padding: 0,
      width: '60px',
    },
  },
  inputBox: {
    background: '#FFFFFF',
    borderRadius: '6px',
    borderColor: '#C7D0D9',
    marginTop: 0,
    fontSize: '14px',
    '&:disabled': {
      backgroundColor: '#F1F4F7',
    },
  },
  hideSvg: {
    '& .MuiFormHelperText-root.Mui-error': {
      color: '#B00020 !important',
      fontSize: '14px !important',
    },
    marginTop: '4px !important',
    '& svg:last-child': {
      display: 'none !important',
    },
  },
  btnAlignLeft: {
    justifyContent: 'flex-start',
    padding: '24px 0px 24px 32px',
    border: `1px solid #c7d0d9`,
  },
  dialogContent: {
    overflow: 'hidden',
    padding: '24px 32px',
  },
  gridContent: {
    paddingBottom: '4px',
  },
  grid: {
    paddingTop: '12px !important',
    paddingBottom: '12px !important',
  },
  toast: {
    margin: '12px 0',
  },
  labelTitle: {
    color: '#666 !important',
    '& span': {
      color: '#FF0000',
    },
  },
  selectRoot: {
    '& div:first-child': {
      backgroundColor: '#F1F4F7',
      borderRadius: '6px 0px 0px 6px',
      borderLeft: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderRight: 'none',
      '&:hover': {
        backgroundColor: '#F1F4F7 !important',
      },
    },
  },
  selectInput: {
    width: '40px',
    fontSize: '14px',
    borderRight: `1px solid #c7d0d9 !important`,
    '&:hover': {
      borderRight: `1px solid #c7d0d9 !important`,
    },
  },
});

class EditContactDetails extends React.PureComponent {
  constructor(props) {
    super(props);
    const { currentContact, getCountryCode, country } = this.props;
    this.state = {
      openDialog: false,
      contactDetail: currentContact.number,
      contactCountryCode: currentContact.countryCode
        ? currentContact.countryCode
        : getCountryCode(country),
      name: {
        contactDetail: 'phone number',
      },
      error: {
        contactDetail: '',
      },
    };
  }

  componentDidUpdate = (prevProps) => {
    const { currentContact, profileDetails } = this.props;

    //alert message when update or create
    if (
      currentContact.number !== prevProps.currentContact.number || //update
      currentContact.countryCode !== prevProps.currentContact.countryCode || //update
      prevProps.profileDetails.phoneNumbers.length !==
        profileDetails.phoneNumbers.length
    ) {
      //create
      this.setState({
        openDialog: false,
      });
      this.props.updateAjaxStatus();
    }
  };

  getContactType = (contact) => {
    if (contact === 'PH') return 'Home';
    else if (contact === 'PM') return 'Mobile';
    else if (contact === 'PW') return 'Work';
    else return '';
  };

  handleOpenClose = () => {
    const { openDialog } = this.state;
    const { currentContact, getCountryCode, country } = this.props;

    this.setState((prevState) => ({
      ...prevState,
      error: { ...prevState.error, contactDetail: '' },
      openDialog: !openDialog,
      contactDetail: currentContact.number,
      contactCountryCode: currentContact.countryCode
        ? currentContact.countryCode
        : getCountryCode(country),
    }));

    this.props.resetAjaxStatus();
    // reset validation message when open promts

    this.props.setActionStatus(!openDialog);
  };

  handleInputChange = (event) => {
    const { target } = event;

    if (target.id === 'contactDetail') {
      const reg = /^[0-9]+$/;
      if (
        reg.test(target.value || target.value === '' || target.value === null)
      ) {
        if (target.value.length < target.minLength) {
          this.setState((prevState) => ({
            ...prevState,
            error: {
              ...prevState.error,
              [target.name]:
                'This entry must be at least ' + target.minLength + ' digits.',
            },
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            [target.name]: target.value,
            error: { ...prevState.error, [target.name]: '' },
          }));
        }
      } else {
        if (!target.value) {
          this.setState((prevState) => ({
            ...prevState,
            error: {
              contactDetail:
                'Please enter the ' + this.state.name['contactDetail'],
            },
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            error: {
              ...prevState.error,
              [target.name]: 'This entry can contain only numbers',
            },
          }));
        }
      }
    } else {
      this.setState((prevState) => ({
        ...prevState,
        [target.name]: target.value,
        error: { ...prevState.error, [target.name]: '' },
      }));
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { profileDetails, currentContact, localisation } = this.props;
    const { error } = this.state;
    const { phoneType } = localisation.prompts;
    const fullName = profileDetails.firstName + ' ' + profileDetails.lastName;

    if (this.state.contactDetail === '' || this.state.contactDetail === null) {
      this.setState((prevState) => ({
        ...prevState,
        error: {
          contactDetail:
            currentContact.number === '' ||
            currentContact.number === null ||
            !/^[0-9]+$/.test(currentContact.number)
              ? 'Please enter the ' + this.state.name['contactDetail']
              : '',
        },
      }));
      return null;
    } else {
      this.props.resetAjaxStatus();
    }

    // check no error message
    if (
      Object.keys(error).filter((e) => this.state.error[e] !== '').length === 0
    ) {
      let model = {
        PhoneType: phoneType[currentContact.type.toUpperCase()],
        PhoneName:
          currentContact.contactName === '' ||
          currentContact.contactName === undefined
            ? fullName
            : currentContact.contactName,
        PhoneNumber: this.state.contactDetail,
        CountryCode: this.state.contactCountryCode,
        IsPrimary: currentContact.preferred === true ? true : false,
      };

      if (currentContact.id !== null) {
        // Customer API doesn't allow to update any phone number if all preferred details = 0
        // if customer edit phone number and all preferred phone numbers = 0, this phone number become preferred
        if (!profileDetails.phoneNumbers.some((x) => x.preferred === true)) {
          model = { ...model, IsPrimary: true };
        }

        this.props.updateCurrentPhoneContact(
          profileDetails.adfitNo,
          currentContact.id,
          JSON.stringify(model)
        );
      } else {
        this.props.createPhoneContact(
          profileDetails.adfitNo,
          JSON.stringify(model)
        );
      }
    }
  };

  render() {
    const { classes, linkText, currentContact, ajax } = this.props;
    const { error } = ajax;
    const contactType = this.getContactType(currentContact.type);

    const stdDropDown = (
      <FormInput
        id="contactCountryCode"
        name="contactCountryCode"
        defaultValue={
          currentContact.countryCode
            ? currentContact.countryCode
            : this.state.contactCountryCode
        }
        onChange={this.handleInputChange}
        classes={{ root: classes.selectRoot, input: classes.selectInput }}
        select>
        <MenuItem value={'+61'}>{'+61'}</MenuItem>
        <MenuItem value={'+64'}>{'+64'}</MenuItem>
      </FormInput>
    );

    const content = (
      <Grid container spacing={4} classes={{ root: classes.gridContent }}>
        <Grid item xs={12} classes={{ root: classes.grid }}>
          <label htmlFor="contactDetail" className={classes.labelTitle}>
            {contactType + ' phone'}
          </label>
          <FormInput
            id="contactDetail"
            name="contactDetail"
            adorment={stdDropDown}
            adormentPosition={'start'}
            inputProps={{ maxLength: 15, minLength: 8 }}
            classes={{
              root: classes.hideSvg,
              input: classes.inputBox,
              adorment: classes.adorment,
            }}
            defaultValue={
              /^[0-9]+$/.test(currentContact.number)
                ? currentContact.number
                : ''
            }
            onChange={this.handleInputChange}
            error={this.state.error.contactDetail !== ''}
            helperText={this.state.error.contactDetail}
            required
          />
        </Grid>
      </Grid>
    );

    return (
      <React.Fragment>
        <TextLink
          to={'#'}
          onClick={this.handleOpenClose}
          className={classes.edit}>
          {linkText}
        </TextLink>
        <Dialog
          className={classes.root}
          classes={{ paper: classes.paper }}
          fullWidth
          open={this.state.openDialog}
          onClose={this.handleOpenClose}>
          <DialogTitle className={classes.split}>
            <Grid container spacing={0}>
              <Grid item xs={12} md={7} classes={{ root: classes.title }}>
                <div>Edit your {contactType.toLowerCase()} phone</div>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                classes={{ root: classes.indicator }}></Grid>
            </Grid>
          </DialogTitle>
          <DialogContent
            classes={{
              root: classes.dialogContent,
            }}>
            {error &&
              (error.status === 400
                ? error.validationErrors.map((c, i) => {
                    return (
                      <ToastMessage
                        key={i}
                        type={'error'}
                        message={c.errorMessage}
                        classes={{ root: classes.toast }}
                      />
                    );
                  })
                : error.statusText && (
                    <ToastMessage
                      type={'error'}
                      message={error.statusText}
                      classes={{ root: classes.toast }}
                    />
                  ))}
            {content}
          </DialogContent>
          <DialogActions classes={{ root: classes.btnAlignLeft }}>
            <Button
              variant="outlined"
              onClick={this.handleSubmit}
              classes={{ outlined: classes.updateButton }}
              text="Update"
            />
            <Button
              variant="outlined"
              onClick={this.handleOpenClose}
              classes={{ outlined: classes.cancelButton }}
              text="Cancel"
            />
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

EditContactDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  linkText: PropTypes.string,
  localisation: PropTypes.object,
};

const mapStateToProps = (state) => ({
  ajax: state.ajax,
  localisation: state.localisation,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setActionStatus: (isEditAction) => {
      dispatch(ajaxActions.setActionStatus(isEditAction));
    },
    updateAjaxStatus: () => {
      dispatch(ajaxActions.updateAjaxStatus());
    },
    resetAjaxStatus: () => {
      dispatch(ajaxActions.resetAjaxStatus());
    },
    updateCurrentPhoneContact: (adfitNo, phoneNumberId, model) => {
      dispatch(
        actionCreators.updateCurrentPhoneContact(adfitNo, phoneNumberId, model)
      );
    },
    createPhoneContact: (adfitNo, model) => {
      dispatch(actionCreators.createPhoneContact(adfitNo, model));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EditContactDetails));
